import { atom } from 'recoil';
// TODO: This should be a global error message set by anything which shows up at the top of the app.
export const generalErrorAtomm = atom<string | null>({
  key: 'generalError',
  default: null,
});
